import {StatusPageTheme} from "@/lib/types/statuspages.ts";
import {InspireTheme} from "./inspire/InspireTheme.tsx";
import {InspirePlusTheme} from "./inspire_plus/InspirePlusTheme.tsx";
import type {ThemeProps} from "./types.ts";

export const ThemeRenderer = (props: ThemeProps) => {
  switch (props.statusPage.theme) {
    case StatusPageTheme.INSPIRE:
      return <InspireTheme {...props} />;
    default:
      return <InspirePlusTheme {...props} />;
  }
};
